/** Részleges pénzügyi nézet, ha a backend még nem ismeri a GET /admin/finance végpontot. */

function parseIso(s) {
  if (!s) return null;
  const d = new Date(String(s).replace("Z", "+00:00"));
  return Number.isNaN(d.getTime()) ? null : d;
}

function monthKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

function dayKey(d) {
  return d.toISOString().slice(0, 10);
}

function emptySeries(keys) {
  return keys.map((period) => ({
    period,
    revenue_huf: 0,
    expense_huf: 0,
    profit_huf: 0,
  }));
}

export function buildFinanceFromAdRequests(adPayload, pricingConfig) {
  const metaCost = Math.max(0, Number(pricingConfig?.finance?.meta_ads_fulfillment_huf) || 25000);
  const unit = Math.max(1, Number(pricingConfig?.custom_credit_unit_price) || 10);
  const metaCredits = Math.max(0, Number(pricingConfig?.addons_weekly?.meta_ads) || 500);
  const metaServiceValue = metaCredits * unit;

  const requests = adPayload?.requests || [];
  const rows = requests
    .filter((r) => r.status === "pending" || r.status === "processed")
    .map((r) => {
      const cost = Number(r.platform_cost_huf) || metaCost;
      return {
        id: `ad-${r.id}`,
        direction: "expense",
        category: "meta_ads",
        title: "Kiadás — Meta hirdetés",
        detail: `Státusz: ${r.status} · szolgáltatás (kredit) ~${metaServiceValue} Ft (${metaCredits} kr)`,
        amount_huf: cost,
        profit_impact_huf: -cost,
        occurred_at: r.requested_at,
      };
    })
    .sort((a, b) => String(b.occurred_at).localeCompare(String(a.occurred_at)));

  const now = new Date();
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);

  let monthExpense = 0;
  for (const row of rows) {
    const d = parseIso(row.occurred_at);
    if (d && d >= monthStart) monthExpense += row.amount_huf;
  }

  const monthNames = [
    "január", "február", "március", "április", "május", "június",
    "július", "augusztus", "szeptember", "október", "november", "december",
  ];

  const finance_settings = {
    meta_ads_fulfillment_huf: metaCost,
    stripe_fee_percent: Number(pricingConfig?.finance?.stripe_fee_percent) || 1.4,
    stripe_fee_fixed_huf: Number(pricingConfig?.finance?.stripe_fee_fixed_huf) || 85,
    szamlazz_hu_per_invoice_huf: Number(pricingConfig?.finance?.szamlazz_hu_per_invoice_huf) || 0,
    szamlazz_hu_monthly_huf: Number(pricingConfig?.finance?.szamlazz_hu_monthly_huf) || 0,
  };

  return {
    partial: true,
    finance_settings,
    month: monthKey(now),
    month_label: `${now.getFullYear()}. ${monthNames[now.getMonth()]}`,
    month_revenue_huf: 0,
    month_expense_huf: monthExpense,
    month_profit_huf: -monthExpense,
    meta_ads_fulfillment_huf: metaCost,
    meta_ads_service_value_huf: metaServiceValue,
    meta_ads_credits: metaCredits,
    rows,
    charts: {
      daily: emptySeries(Array.from({ length: 30 }, (_, i) => {
        const d = new Date(now);
        d.setDate(d.getDate() - (29 - i));
        return dayKey(d);
      })),
      monthly: emptySeries(Array.from({ length: 12 }, (_, i) => {
        const d = new Date(now.getFullYear(), now.getMonth() - (11 - i), 1);
        return monthKey(d);
      })),
      yearly: emptySeries([String(now.getFullYear())]),
    },
  };
}
